import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
function PospressoPlusLive() {
  return (
    <div className="bg-light py-4">

      <Container>

        {/* TITLE */}
        <h2 className="text-center mb-3">POSPRESSO PLUS SYSTEM</h2>
        <p className="text-center text-muted mb-4">
          Restaurant , Bar and parking Management Demo Access
        </p>

        {/* 3 COLUMNS */}
        <Row className="g-4">

          {/* ADMIN */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>

              

     <Button className="w-100" variant="primary">
                   Admin    Login 
                  </Button>



                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="02" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="admin" readOnly />
                  </Form.Group>

              

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="123456" readOnly />
                  </Form.Group>

             
                </Form>

              </Card.Body>
            </Card>
          </Col>

          {/* WAITER */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>

       

          <Button className="w-100" variant="success">
                            Waiter   Login 
                            </Button>


                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="01" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="waiter" readOnly />
                  </Form.Group>

                

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="123456" readOnly />
                  </Form.Group>

                  
                </Form>

              </Card.Body>
            </Card>
          </Col>

          {/* CASHIER */}
          <Col md={4}>
            <Card className="shadow-sm h-100">
              <Card.Body>

    <Button className="w-100" variant="warning">
                    Cashier   Login 
                  </Button>


                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="4" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="cashier" readOnly />
                  </Form.Group>

                  

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="123456" readOnly />
                  </Form.Group>

              
                </Form>

              </Card.Body>
            </Card>
          </Col>

        </Row>

        {/* LIVE DEMO BUTTON */}
        <div className="text-center mt-4">
          <a
           href="https://pospresso.plus.chrisalphatech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              style={{
                backgroundColor: "#0d6efd",
                border: "none"
              }}
            >
               Open Live Demo
            </Button>
          </a>
              <Link 
        to="/pospresso_plus" 
        style={{ 
          color: "#0d6eff", 
          fontWeight: "500",
          marginLeft: "20px"
        }}
      >
        Read More 
      </Link>
                
        </div>

      </Container>

    </div>
  );
}

export default PospressoPlusLive;